<template>
  <div class="container my-14">
    <div class="row items-center justify-center">
      <h1
        class="text-[#000] title-head text-center text-[60px] uppercase font-semibold"
      >
        Features
      </h1>
      <div class="rounded-3xl bg-[#FFF000] p-12 my-[3rem]">
        <div
          class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 h-full items-center"
        >
          <div
            class="md:col-span-2 lg:col-span-1 sm:col-span-2 lg:order-[0] order-[1] sm:order-[1] md:mt-8 sm:mt-8"
          >
            <h1
              class="text-[#000] uppercase text-[44px] font-Approach leading-[1.2] mb-6"
            >
              Client <br />
              MANAGEMENT
            </h1>
            <p class="text-[#000] font-medium [line-height: 28px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since.
            </p>
            <ul class="list-disc my-4 px-10">
              <li class="text-[#000] text-[22px] mt-5 mb-3">Sub feature</li>
              <li class="text-[#000] text-[22px] mb-3">Sub feature</li>
              <li class="text-[#000] text-[22px]">Sub feature</li>
            </ul>
            <button
              class="clip-btn bg-[#000] justify-center gap-5 flex items-center"
            >
              <span>Show More</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="8"
                viewBox="0 0 9 8"
                fill="none"
              >
                <path
                  d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </button>
          </div>
          <div class="md:col-span-2 lg:col-span-3 sm:col-span-2">
            <img
              class="w-full rounded-xl"
              src="@/assets/images/Dashboard - Flowbase 1.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="rounded-3xl bg-[#00D2DC] p-12 my-[3rem]">
        <div
          class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 h-full items-center h-full items-center"
        >
          <div
            class="md:col-span-2 lg:col-span-1 sm:col-span-2 lg:order-[0] order-[1] sm:order-[1] md:mt-8 sm:mt-8"
          >
            <h1
              class="text-[#FFF] uppercase text-[44px] font-Approach leading-[1.2] mb-6"
            >
              Client <br />
              MANAGEMENT
            </h1>
            <p class="text-[#FFF] font-medium [line-height: 28px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since.
            </p>
            <ul class="list-disc my-4 px-10">
              <li class="text-[#FFF] text-[22px] mt-5 mb-3">Sub feature</li>
              <li class="text-[#FFF] text-[22px] mb-3">Sub feature</li>
              <li class="text-[#FFF] text-[22px]">Sub feature</li>
            </ul>
            <button
              class="clip-btn bg-[#000] justify-center gap-5 flex items-center"
            >
              Show More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="8"
                viewBox="0 0 9 8"
                fill="none"
              >
                <path
                  d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </button>
          </div>
          <div class="col-span-3">
            <img
              class="w-full rounded-xl"
              src="@/assets/images/Dashboard - Flowbase 1.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="rounded-3xl bg-[#514ED8;] p-12 my-[3rem]">
        <div
          class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 h-full items-center h-full items-center"
        >
          <div
            class="md:col-span-2 lg:col-span-1 sm:col-span-2 lg:order-[0] order-[1] sm:order-[1] md:mt-8 sm:mt-8"
          >
            <h1
              class="text-[#FFF] uppercase text-[44px] font-Approach leading-[1.2] mb-6"
            >
              Client <br />
              MANAGEMENT
            </h1>
            <p class="text-[#FFF] font-medium [line-height: 28px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since.
            </p>
            <ul class="list-disc my-4 px-10">
              <li class="text-[#FFF] text-[22px] mt-5 mb-3">Sub feature</li>
              <li class="text-[#FFF] text-[22px] mb-3">Sub feature</li>
              <li class="text-[#FFF] text-[22px]">Sub feature</li>
            </ul>
            <button
              class="clip-btn bg-[#000] justify-center gap-5 flex items-center"
            >
              Show More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="8"
                viewBox="0 0 9 8"
                fill="none"
              >
                <path
                  d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </button>
          </div>
          <div class="col-span-3">
            <img
              class="w-full rounded-xl"
              src="@/assets/images/Dashboard - Flowbase 1.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Features-Component",
};
</script>
<style lang="scss">
@import "~/public/styles/features/index.scss";
</style>
